// extracted by mini-css-extract-plugin
export default {"classes":"StudentDashboard_classes__oo9ji"};